module.exports = "https://r.nearpod.com/assets/media/image/next-arrow-8368f3d67f7a9a42f25a6c5a590abb03.svg";